import { render, staticRenderFns } from "./MilkTeaSetting.vue?vue&type=template&id=6e914b8e&scoped=true"
import script from "./MilkTeaSetting.vue?vue&type=script&lang=js"
export * from "./MilkTeaSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e914b8e",
  null
  
)

export default component.exports